module.exports = __webpack_public_path__ + "static/media/1.b33c7192.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/1.jpg
// module id = 77
// module chunks = 0